// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItensStatus_GetByIdResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/menu_itens_status/getByID/{id}
 *
 * Returns a single menu item status record
 * (Menu_itens_status_model::getById()).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MenuItensStatus_GetByIdResponseDados {
menu_item_status_id: number
menu_item_status_titulo: string
}

export type MenuItensStatus_GetByIdResponse = ApiResponse<MenuItensStatus_GetByIdResponseDados>;

registerResponseContract('MenuItensStatus_GetByIdResponse', {
  menu_item_status_id:     { type: 'number',  required: true },
  menu_item_status_titulo: { type: 'string',  required: true },
})
